import "./components/ex.js";
import "./components/slider.js";
